import notification from 'antd/lib/notification'

import 'antd/lib/notification/style'

export * from 'antd/lib/notification'

export default notification
